module.exports = __webpack_public_path__ + "static/assets/b2581839529721aac9ead3b0a0435d9d.png";